import { createSelector } from '@ngrx/store';

import { Entity, User } from '@apps/auth/domain/models/back';

import { UserExploitComparer, usersAdapter } from '../../users/users.common';
import { IBackAuthEntitiesState } from '../entities.state';
import { DetailedEntity, sitesAdapter } from '../entities.common';
import { getBackAuthEntitiesState } from '../entities.selectors';
import { BackAuthEntitiesGlobalFeatureKey, IBackAuthEntitiesGlobalState } from './entities-global.reducer';

export const getBackAuthEntitiesGlobalState = createSelector(
    getBackAuthEntitiesState,
    (state: IBackAuthEntitiesState) =>
        state[BackAuthEntitiesGlobalFeatureKey]
);
const getDetailedEntityState = createSelector(
    getBackAuthEntitiesGlobalState,
    (state: IBackAuthEntitiesGlobalState): DetailedEntity =>
        state.selected
);
export const getSelectedEntity = createSelector(
    getDetailedEntityState,
    (detailedEntity: DetailedEntity): Entity =>
        detailedEntity.entity
);

export const getBackEntitiesFilter = createSelector(
    getBackAuthEntitiesState,
    (state: IBackAuthEntitiesState) =>
        null // state.oData.filter
);

const getEntityReferentsState = createSelector(
    getDetailedEntityState,
    (detailedEntity: DetailedEntity) =>
        detailedEntity.referents
);
export const {
    selectAll: getEntityReferents
} = usersAdapter.getSelectors(getEntityReferentsState);

const getEntitySitesState = createSelector(
    getDetailedEntityState,
    (detailedEntity: DetailedEntity) =>
        detailedEntity.sites
);
export const {
    selectAll: getEntitySites
} = sitesAdapter.getSelectors(getEntitySitesState);

const getEntityUsersState = createSelector(
    getDetailedEntityState,
    (detailedEntity: DetailedEntity) =>
        detailedEntity.users
);
export const {
    selectAll: getEntityUsers
} = usersAdapter.getSelectors(getEntityUsersState);

const getQuickSearchedEntityUsersImpe = createSelector(
    getBackAuthEntitiesGlobalState,
    getEntityUsers,
    (state: IBackAuthEntitiesGlobalState, users: User[]) =>
    {
        const searchRegex = new RegExp(state.qsWordImpeUsers, 'i');

        return users.filter((user: User) =>
            searchRegex.test(`${user.firstLastName}|${user.email}|${user.entityName}|${user.title}`)
        );
    }
);
export const getPipelinedEntityUsersImpe = createSelector(
    getQuickSearchedEntityUsersImpe,
    (users: User[]) =>
    // (users: User[], params: { comparer: Comparer<User> }) =>
        [...users].sort(UserExploitComparer)
);
export const getPipelinedEntitiesExternal = createSelector(
    getBackAuthEntitiesGlobalState,
    getEntityUsers,
    (state: IBackAuthEntitiesGlobalState, users: User[]) =>
    {
        const searchRegex = new RegExp(state.qsWordImpeUsers, 'i');

        return users.filter((user: User) =>
            searchRegex.test(`${user.firstLastName}|${user.email}|${user.entityName}|${user.title}`)
        );
    }
);
export const getEntityContacts = createSelector(
    getEntityUsers,
    (users: User[]) =>
        users.filter((user: User) =>
            user.isContact)
);
export const getEntityUsersQueryString = createSelector(
    getBackAuthEntitiesGlobalState,
    (state: IBackAuthEntitiesGlobalState) =>
        state.entityUsersQueryParameters.size !== 0 ?
            `?${Array.from(state.entityUsersQueryParameters, ([key, value]) => `${key = value}`).join('&')}`
            : ''
);
